export default __webpack_public_path__ + "static/media/maintenanceWindow.686f8e7b.svg";